
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

var $TypeError = TypeError;

var validateArgumentsLength = function (passed, required) {
  if (passed < required) throw new $TypeError('Not enough arguments');
  return passed;
};

export { validateArgumentsLength as default };
//# sourceMappingURL=validate-arguments-length.js.map
